class LocalizationForm extends HTMLElement {
  elements: {
    input: HTMLInputElement | null
    list: HTMLElement | null
  }

  selectors = {
    name: 'data-name',
    value: 'data-value'
  }

  constructor() {
    super()
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      list: this.querySelector('[data-country-list]')
    }
  }

  connectedCallback() {
    this.fetchElements()
    this.addEventListeners()
  }

  fetchElements() {
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      list: this.querySelector('[data-country-list]')
    }
  }

  addEventListeners() {
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)))
  }

  onItemClick(event: Event) {
    event.preventDefault()
    const form = this.querySelector('form')
    const target = event.target as HTMLElement
    const dataElement = target.closest('[data-value]') as HTMLElement | null

    if (!this.elements.input || !dataElement?.dataset.value) return
    this.elements.input.value = dataElement.dataset.value
    if (form) form.submit()
  }
}

customElements.define('localization-form', LocalizationForm)
